import './inclusivelyhidden_xj9y1v.css';
import { jsx } from 'react/jsx-runtime';

/* 
This utility class shrinks an element into a 1px square, hiding any overflow, 
and absolutely positioning the element to remove any trace of it from the normal document flow. 
This utility class is ideal for providing screen reader-only text.
https://www.sarasoueidan.com/blog/inclusively-hiding-and-styling-checkboxes-and-radio-buttons/
*/
const srOnly = "s1rybhvf";
const InclusivelyHidden = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx("span", {
    className: srOnly,
    ...rest,
    children: children
  });
};
InclusivelyHidden.displayName = 'InclusivelyHidden';
var InclusivelyHidden$1 = InclusivelyHidden;

export { InclusivelyHidden$1 as InclusivelyHidden, InclusivelyHidden$1 as default };
